import React from "react";
import FromPageIndicator from "../Components/Common/FromPageIndicator";

const Terms = () => {
  return (
    <div>
      <FromPageIndicator />
      <div
        className="container my-3 mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-4xl mb-6 sm:mb-10 mt-16 sm:mt-24 md:mt-32"
        style={{
          lineHeight: "1.6",
        }}
      >
        <h1 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8 text-center">
          Terms and Conditions
        </h1>

        <section className="mb-6 sm:mb-8 bg-gray-50 p-4 sm:p-6 rounded-lg">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 border-b pb-2">
            1. Registration Policy
          </h2>
          <p className="mb-3">
            Registration is mandatory for all attendees of the 28th Annual
            Conference of the Association of Medical Physicists of India (TNPY
            AMPICON 2025), to be held on 26th–27th September 2025 at Apollo
            Speciality Hospitals, Vanagaram, Chennai.
          </p>
          <p className="mb-3">
            Early bird registration ends on 15th August 2025. All payments must
            be made in advance to secure participation.
          </p>
        </section>

        <section className="mb-6 sm:mb-8 bg-gray-50 p-4 sm:p-6 rounded-lg">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 border-b pb-2">
            2. Payment and Refund Policy
          </h2>
          <p className="mb-3">
            Registration fees once paid are non-refundable. All refund inquiries
            must be submitted within 7 days of registration.
          </p>
        </section>

        <section className="mb-6 sm:mb-8 bg-gray-50 p-4 sm:p-6 rounded-lg">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 border-b pb-2">
            3. Workshop Participation
          </h2>
          <p className="mb-3">
            The Pre-conference Hands-on Workshop on 26th September 2025 has
            limited seating available.
          </p>
          <p className="mb-3">
            Separate registration is required for workshop participation and
            will be confirmed on a first-come, first-served basis.
          </p>
        </section>

        <section className="mb-6 sm:mb-8 bg-gray-50 p-4 sm:p-6 rounded-lg">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 border-b pb-2">
            4. Abstract Submissions
          </h2>
          <p className="mb-3">
            Abstract submission deadline is 20th August 2025. All submissions
            must adhere to the format specified on the conference website.
          </p>
          <p className="mb-3">
            Authors of accepted abstracts must register for the conference to
            present their work.
          </p>
          <p className="mb-3">
            The scientific committee reserves the right to accept or reject
            abstracts based on quality and relevance to the conference theme.
          </p>
        </section>

        <section className="mb-6 sm:mb-8 bg-gray-50 p-4 sm:p-6 rounded-lg">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 border-b pb-2">
            5. Intellectual Property
          </h2>
          <p className="mb-3">
            By registering for the conference, participants consent to the
            recording and photography of sessions for promotional and archival
            purposes.
          </p>
          <p className="mb-3">
            Presentations remain the intellectual property of their respective
            authors.
          </p>
          <p className="mb-3">
            Unauthorized recording or reproduction of presentations is strictly
            prohibited.
          </p>
        </section>

        <section className="bg-gray-50 p-4 sm:p-6 rounded-lg">
          <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 border-b pb-2">
            6. Contact Information
          </h2>
          <p className="mb-3">
            For any queries regarding these terms and conditions, please contact
            the organizing committee:
          </p>
          <ul className="list-disc pl-5 sm:pl-8 mb-4 space-y-1">
            <li>
              By email:{" "}
              <a
                href="mailto:ampicon2025@apollohospitals.com"
                className="text-blue-600 hover:text-blue-800 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                ampicon2025@apollohospitals.com
              </a>
            </li>
            <li>By phone: +91 44 40401066</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Terms;
